import { createContext } from 'react';

export type TableContextModel = {
  readonly columnCount: number;
};

export const TableContext = createContext<TableContextModel>({ columnCount: 0 });
